module.exports = __webpack_public_path__ + "static/media/slide4-final.5324bb70.png";